<div class="finish-main">
    <p class="finish-title">¡ Gracias por registrarte !</p>
    <button (click)="onClick()" type="button" class="finish-button" mat-raised-button>Volver</button>
</div>